import { Api } from "@core/api/api";
import { CountryIndicator } from "@domain/currentProfile/countriesIndicators";
import { userKycFromDto, UserKycFromDto, userKycToDto } from "./dto";
import { UserKyc } from "./userKyc";
import { UserKycDraft } from "./userKycDraft";

const USER_KYC_URL = "/persons/kycs";
const OPT_URL = "/otps";

export class UserKycApi {
	constructor(private readonly api: Api) {}

	async getKyc(): Promise<UserKyc> {
		const result = await this.api.get<UserKycFromDto>(`${USER_KYC_URL}`);
		return userKycFromDto(result.data);
	}

	async create(draft: UserKycDraft): Promise<UserKyc> {
		const result = await this.api.post<UserKycFromDto>(`${USER_KYC_URL}`, userKycToDto(draft));
		return userKycFromDto(result.data);
	}

	async checkNumber(indicative: CountryIndicator, phoneNumber: string): Promise<void> {
		await this.api.post(`${OPT_URL}`, { phoneNumber, indicative });
	}
	async checkCode(code: string): Promise<boolean> {
		const result = await this.api.get<boolean>(`${OPT_URL}/checkCode/${code}`);
		return result.data;
	}
}
